import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import api from '../../../connector/api';

export default function SchoolYearModal({ year, onClose, onSuccess }) {
    const [name, setName] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        if (year) {
            setName(year.name || '');
            setStartDate(year.start_date || '');
            setEndDate(year.end_date || '');
        } else {
            setName('');
            setStartDate('');
            setEndDate('');
        }
    }, [year]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        const payload = { name, start_date: startDate, end_date: endDate };

        try {
            if (year?.id) {
                await api.put(`/years/${year.id}/`, payload);
                toast.success("School year updated successfully.");
            } else {
                await api.post('/years/', payload);
                toast.success("School year created successfully.");
            }
            onSuccess();
        } catch (err) {
            console.error("Failed to save school year:", err);
            toast.error("Failed to save school year.");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="fixed inset-0 w-screen h-screen z-50 flex items-center justify-center p-4 bg-black/40 backdrop-blur-xs">
            <div className="bg-white border border-zinc-200 rounded-lg max-w-md w-full shadow-xl p-6 space-y-4">
                <div className="flex items-center justify-between border-b border-zinc-100 pb-3">
                    <h3 className="text-sm font-bold text-zinc-900">
                        {year ? 'Edit School Year' : 'Add New School Year'}
                    </h3>
                    <button onClick={onClose} className="text-zinc-400 hover:text-zinc-600 text-xs">
                        ✕
                    </button>
                </div>

                <form onSubmit={handleSubmit} className="space-y-4">
                    <div className="space-y-1">
                        <label className="text-xs font-medium text-zinc-700 block">Name</label>
                        <input
                            type="text"
                            placeholder="e.g. 2025-2026"
                            className="w-full text-xs text-zinc-900 bg-zinc-50 border border-zinc-200 rounded-lg px-3 py-2 outline-none focus:border-blue-500 focus:bg-white transition-colors"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            required
                        />
                    </div>

                    <div className="grid grid-cols-2 gap-3">
                        <div className="space-y-1">
                            <label className="text-xs font-medium text-zinc-700 block">Start Date</label>
                            <input
                                type="date"
                                className="w-full text-xs text-zinc-900 bg-zinc-50 border border-zinc-200 rounded-lg px-3 py-2 outline-none focus:border-blue-500 focus:bg-white transition-colors"
                                value={startDate}
                                onChange={(e) => setStartDate(e.target.value)}
                                required
                            />
                        </div>
                        <div className="space-y-1">
                            <label className="text-xs font-medium text-zinc-700 block">End Date</label>
                            <input
                                type="date"
                                className="w-full text-xs text-zinc-900 bg-zinc-50 border border-zinc-200 rounded-lg px-3 py-2 outline-none focus:border-blue-500 focus:bg-white transition-colors"
                                value={endDate}
                                onChange={(e) => setEndDate(e.target.value)}
                                required
                            />
                        </div>
                    </div>

                    <div className="flex justify-end gap-2 pt-2">
                        <button
                            type="button"
                            onClick={onClose}
                            className="px-3 py-1.5 text-xs font-medium text-zinc-600 bg-zinc-100 hover:bg-zinc-200 rounded-lg transition-colors"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            disabled={submitting}
                            className="px-3 py-1.5 text-xs font-semibold text-white bg-blue-600 hover:bg-blue-700 rounded-lg transition-colors shadow-sm disabled:opacity-50"
                        >
                            {submitting ? "Saving..." : year ? "Update Year" : "Create Year"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}